

import React, { useState } from "react";
import "./Homepage.scss";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import AA from "../../Images/AA.png";
import BB from "../../Images/BB.png";
import CC from "../../Images/CC.png";
import DD from "../../Images/DD.png";
import EE from "../../Images/EE.png";
import FF from "../../Images/FF.png";
import GG from "../../Images/GG.png";
import LL from "../../Images/LL.webp";
import HH from "../../Images/HH.png";
import II from "../../Images/II.jpg";
import JJ from "../../Images/JJ.png";
import KK from "../../Images/KK.webp";
import Icon1 from "../../Images/Icon1.png";
import Icon3 from "../../Images/Icon3.png";
import { Link } from "react-router-dom";

export default function First() {


  const slideImages = [
    [
      {
        url: AA,
        caption: "HTML",
      },
      {
        url: BB,
        caption: "CSS",
      },
      {
        url: CC,
        caption: "JavaScript",
      },
      {
        url: DD,
        caption: "ReactJS",
      },
    ],
    [
      {
        url: EE,
        caption: "TypeScript",
      },
      {
        url: FF,
        caption: "jQuery",
      },
      {
        url: GG,
        caption: "Bootstrap",
      },
      {
        url: LL,
        caption: "CSS Processors",
      },
    ],
    [
      {
        url: HH,
        caption: "NodeJS",
      },
      {
        url: II,
        caption: "ExpressJS",
      },
      {
        url: JJ,
        caption: "MongoDB",
      },
      {
        url: KK,
        caption: "SQL",
      },
    ],
  ];
return (<div className="ssecond">
  <h1>Skills</h1>

<Slide>
            {slideImages.map((elem, index) => (
              <div className="each-slide" key={index}>
                <div>
                  <div
                    className="slid"
                    style={{ backgroundImage: `url(${elem[0].url})` }}
                  />
                  <div>{elem[0].caption}</div>
                </div>
                <div>
                  <div
                    className="slid"
                    style={{ backgroundImage: `url(${elem[1].url})` }}
                  />
                  <div>{elem[1].caption}</div>
                </div>
                <div>
                  <div
                    className="slid"
                    style={{ backgroundImage: `url(${elem[2].url})` }}
                  />
                  <div>{elem[2].caption}</div>
                </div>
                <div>
                  <div
                    className="slid"
                    style={{ backgroundImage: `url(${elem[3].url})` }}
                  />
                  <div>{elem[3].caption}</div>
                </div>
              </div>
            ))}
          </Slide>

    </div>
  )
}
